import * as React from 'react';
import { useRecordContext } from 'react-admin';
import { get } from 'lodash';
import { Grid, Box, Accordion, AccordionSummary, Typography, AccordionDetails } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';

import { accordionSummaryStyles, sectionTitleStyle } from 'src/styles';
import HospitalCenterInfo from './HospitalCenterInfo';
import { Hospital } from 'src/components/Employees/types';
import { palette } from 'src/Theme';
import { HospitalsMock } from 'src/api/mocks/HospitalsMock';

export const HospitalCenterInfoTab: React.FC<{ hasEditPermission?: boolean }> = ({ hasEditPermission = false }) => {
    const record = useRecordContext();
    const hospitals = record.hospitals || [];

    const [expandedIndex, setExpandedIndex] = React.useState<number | boolean>(
        hospitals.length > 0 ? hospitals.length - 1 : false
    );

    const handleAccordionToggle = (index: number) => {
        setExpandedIndex((prevIndex) => (prevIndex === index ? false : index));
    };

    return (
        <Grid p={3} container columnSpacing={4} rowSpacing={1}>
            <Grid item xs={12}>
                <Box sx={sectionTitleStyle}>Лікарні в освітньому центрі</Box>
            </Grid>
            <Grid item xs={12}>
                {hospitals.map((hospital: Hospital, index: number) => {
                    return (
                        <Accordion
                            key={index}
                            disableGutters
                            expanded={expandedIndex === index}
                            onChange={() => handleAccordionToggle(index)}
                            sx={{
                                boxShadow: 'none'
                            }}>
                            <AccordionSummary
                                expandIcon={<ExpandMore />}
                                aria-controls={`${hospital}-content`}
                                id={`${hospital}-header`}
                                sx={{
                                    ...accordionSummaryStyles,
                                    //color: isActive ? 'inherit' : palette.primary.grayBluish,
                                    backgroundColor:
                                        expandedIndex === index ? accordionSummaryStyles.backgroundColor : 'transparent'
                                }}>
                                <Box sx={{ flex: '1 1 50%', paddingLeft: '0.4em' }}>
                                    <Typography sx={{ fontWeight: '500', color: palette.primary.midnightBlue }}>
                                        {hospital.name}
                                    </Typography>
                                </Box>
                            </AccordionSummary>
                            <AccordionDetails sx={{ padding: '0 0 0 2em' }}>
                                <HospitalCenterInfo hospital={hospital} />
                            </AccordionDetails>
                        </Accordion>
                    );
                })}
            </Grid>
        </Grid>
    );
};

export default HospitalCenterInfoTab;
